<template>
  <el-input id="editInput" v-model.trim="value" class="edit-input" :maxlength="maxlength" :size="size">
    <i slot="suffix" class="suffix-icon el-input__icon el-icon-check" @click.stop="handleOk" />
    <i slot="suffix" class="suffix-icon el-input__icon el-icon-close" @click.stop="handleCancel" />
  </el-input>
</template>

<script>
export default {
  name: 'EditInput',
  props: {
    // 初始值
    initValue: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number
    },
    size: {
      type: String
    }
  },
  data() {
    return {
      value: '',
    }
  },
  watch: {
    initValue: {
      handler(newVal) {
        this.value = newVal
      },
      immediate: true
    }
  },
  methods: {
    toFocus() {
      document.getElementById('editInput').focus()
    },
    handleOk() {
      this.$emit('edit-confirm', this.value)
    },
    handleCancel() {
      this.$emit('edit-cancel', this.value)
    },
  }
}
</script>

<style lang="less" scoped>
.suffix-icon{
  width: 20px;
  &.el-icon-check{
    color: @success-color;
  }
  &.el-icon-close{
    color: @error-color;
  }
}
</style>
